var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowToVote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2158_5038",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2158_5038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.19244 21.6153C4.68731 21.6153 4.25975 21.4403 3.90977 21.0903C3.55977 20.7404 3.38477 20.3128 3.38477 19.8077V15.9308L6.36554 12.5558L7.43474 13.625L4.99242 16.3846H19.0078L16.6155 13.675L17.6847 12.6058L20.6155 15.9308V19.8077C20.6155 20.3128 20.4405 20.7404 20.0905 21.0903C19.7405 21.4403 19.3129 21.6153 18.8078 21.6153H5.19244ZM5.19244 20.1154H18.8078C18.8911 20.1154 18.9632 20.0849 19.0242 20.024C19.0851 19.9631 19.1155 19.891 19.1155 19.8077V17.8846H4.88472V19.8077C4.88472 19.891 4.91517 19.9631 4.97607 20.024C5.03698 20.0849 5.10911 20.1154 5.19244 20.1154ZM10.7597 14.1442L7.50399 10.8692C7.15271 10.5179 6.98123 10.092 6.98957 9.59133C6.9979 9.0907 7.17771 8.66474 7.52899 8.31346L12.1694 3.67311C12.5206 3.32183 12.9475 3.14106 13.4501 3.13081C13.9527 3.12054 14.3796 3.29105 14.7309 3.64233L17.9962 6.90771C18.3475 7.25898 18.5283 7.68077 18.5385 8.17308C18.5488 8.66538 18.3783 9.08718 18.027 9.43846L13.3059 14.1596C12.9546 14.5109 12.5302 14.6839 12.0328 14.6788C11.5354 14.6737 11.111 14.4955 10.7597 14.1442ZM16.9328 8.40963C16.9841 8.35835 17.0097 8.28463 17.0097 8.18846C17.0097 8.09229 16.9841 8.01857 16.9328 7.96728L13.6867 4.72116C13.6354 4.66988 13.5617 4.64423 13.4655 4.64423C13.3693 4.64423 13.2956 4.66988 13.2443 4.72116L8.57319 9.39228C8.52191 9.44357 8.49627 9.51729 8.49627 9.61346C8.49627 9.70963 8.52191 9.78335 8.57319 9.83463L11.8193 13.0808C11.8706 13.132 11.9443 13.1577 12.0405 13.1577C12.1367 13.1577 12.2104 13.132 12.2617 13.0808L16.9328 8.40963Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToVote);
export default __webpack_public_path__ + "static/media/how_to_vote.8acfb6917ee44131d8e7eab53dbe802d.svg";
export { ForwardRef as ReactComponent };